export default __webpack_public_path__ + "static/media/gijs.df077952.png";